import { call, type CallEffect, put, type PutEffect, takeLatest } from 'redux-saga/effects'
import { type AnyAction } from 'redux'

import AuthenticationService from '@api/AuthenticationService'
import { handleLogin, handleLoginSuccess, handleLoginFailure } from '@store/slices/Authentication.slice'
import { type LoginResponseType } from '@app-types/AuthenticationTypes'

function* watchHandleLogin(
    action: ReturnType<typeof handleLogin>
): Generator<CallEffect<LoginResponseType> | PutEffect<AnyAction>, void, LoginResponseType> {
    const { signingMethod, ssn, langId, metadata } = action.payload
    try {
        const response = yield call(AuthenticationService.handleLogin, signingMethod, langId, metadata, ssn)
        yield put(handleLoginSuccess(response))
    } catch (error) {
        yield put(handleLoginFailure(error))
    }
}

const authenticationSaga = [takeLatest(handleLogin, watchHandleLogin)]

export default authenticationSaga
